interface Props {
  icon: string;
  title: string;
  action: () => void;
  active?: boolean;
}

const DropdownItem = ({
  icon, title, action, active,
}: Props) => (
  <span
    className={`dropdown-item ${active ? 'active' : ''}`}
    role="button"
    onClick={action}
    onKeyDown={action}
    tabIndex={0}
  >
    {icon && (
      <i className={`fas ${icon} fa-sm fa-fw mr-2 text-gray-400`} />
    )}
    {title}
  </span>
);

DropdownItem.defaultProps = {
  active: undefined,
};

export default DropdownItem;
